module.exports = __webpack_public_path__ + "static/media/zeroe0x.2abf5e98.png";